<span class="block text-shui-text-strong text-sm truncate px-2"><ng-content></ng-content></span>
